export default __webpack_public_path__ + "static/media/bg4.23972ce6.jpg";